import axiosInstance from '@/services/axiosInstance';
import { pickBody } from '@/api/helpers';

export type CalendarNote = {
  id: string;
  organizationId: string;
  calendarId: string | null;
  title: string | null;
  body: string;
  color: string | null;
  pinned: boolean;
  happensAt: string | null;
  reminderOffsetsMinutes?: number[] | null;
  createdById: string;
  updatedById: string | null;
  createdAt: string;
  updatedAt: string;
};

type ListResponse = { success?: boolean; data: CalendarNote[] };

export type ListNotesParams = {
  calendarId?: string;
  pinned?: boolean;
  from?: string;
  to?: string;
};

const list = (params?: ListNotesParams): Promise<CalendarNote[]> =>
  axiosInstance.get<unknown>('/api/v1/notes', { params }).then((res) => {
    const raw = pickBody<ListResponse | CalendarNote[]>(res.data);
    if (Array.isArray(raw)) return raw;
    return raw?.data ?? [];
  });

export type CreateNoteInput = {
  title?: string | null;
  body: string;
  color?: string | null;
  pinned?: boolean;
  calendarId?: string | null;
  happensAt?: string | null;
  reminderOffsetsMinutes?: number[];
};

const create = (input: CreateNoteInput): Promise<CalendarNote> =>
  axiosInstance.post<unknown>('/api/v1/notes', input).then((res) => {
    const raw = pickBody<{ success?: boolean; data: CalendarNote }>(res.data);
    return raw.data;
  });

const remove = (id: string): Promise<void> =>
  axiosInstance.delete(`/api/v1/notes/${id}`).then(() => undefined);

const notesApi = {
  list,
  create,
  remove,
};

export { notesApi };
